import { Box, LoaderNew } from '@jfs/ui-new'
import { useIsLargeScreen } from '@jfs/utils'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useEffect, useLayoutEffect, useState } from 'react'
import { ModBox } from '../../../../comps/ModifiedBox/ModifiedBox'
import { staticStrings } from '../../../../data/static/strings'
import { useLazyApiData, useStores } from '../../../../data/store'
import { Routes } from '../../../../nav/routes'
import { isMobile } from '../../../../util/util'
import { AddNewUserForm } from '../AddNewUser/AddNewUserForm'
import { AddNewUserInterface } from '../AddNewUser/AddNewUserInterface'
import { Header } from '../AddNewUser/Header'
import { styles } from '../AddNewUser/styles'

const EditUserRole = ({ hide, route }: AddNewUserInterface) => {
  const navigation = useNavigation()
  const passedData = route?.params ?? {}
  const [loading, setLoading] = useState(true)

  const { getPermissionList, mid, getUserOptedPermissions, masterDataList, getMasterPermissionCheckboxData, hasSupersetPermission } =
    useStores((store) => ({
      getPermissionList: store.userManagement.getUserPermissions,
      mid: store.user.selectedMid,
      getUserOptedPermissions: store.userManagement.getUserOptedPermissions,
      masterDataList: store.userManagement.masterPermissionList,
      getMasterPermissionCheckboxData: store.userManagement.getMasterPermissionCheckboxData,
      hasSupersetPermission: store?.userManagement?.hasSupersetPermission(),
    }))

  const accessRightsData = getUserOptedPermissions()

  const [getUserPermissions, userPermissionHandler] = useLazyApiData(getPermissionList)
  const [getMasterPermissionApi, getMasterPermissionApiHandler] = useLazyApiData(getMasterPermissionCheckboxData)
  const { state } = userPermissionHandler
  const isLoading = state === 'pending' || loading === true || getMasterPermissionApiHandler.state === 'pending'
  const isEditing = passedData !== undefined
  const getJfsUserId = passedData?.id ?? ''

  const isFocused = useIsFocused()

  const isLargeScreen = useIsLargeScreen()
  const isMob = isMobile(isLargeScreen)
  useLayoutEffect(() => {
    const postData = {
      jfsUserId: getJfsUserId,
      entityId: mid,
    }
    getUserPermissions(postData, isMob, false)
  }, [getJfsUserId, getUserPermissions, mid])

  useEffect(() => {
    if (masterDataList === null) {
      getMasterPermissionApi()
    }
  }, [getMasterPermissionApi, masterDataList])

  useEffect(() => {
    if (state === 'fulfilled') {
      setLoading(false)
    } else if (state === 'rejected' || getMasterPermissionApiHandler.state === 'rejected') {
      let canGoBack = navigation?.canGoBack()
      setLoading(false)
      if (canGoBack && isFocused) {
        //If the API fails then check if there is any parent screen if yes then the user can go back!
        // navigation?.goBack()
      } else if (isFocused) {
        //When we refresh the page then there is no parent screen so obviously there is no root of going back. So we need to navigate the user to setting screen.
        navigation?.navigate(Routes.SETTINGS, { params: staticStrings.userManagement })
      }
    }
  }, [getMasterPermissionApiHandler.state, isFocused, navigation, state])

  if (hide) {
    return null
  }

  if (isLoading) {
    return (
      <Box {...styles.centerAlign}>
        <LoaderNew />
      </Box>
    )
  }
  return (
    <Box {...styles.superParent}>
      <ModBox {...styles.maincontainer}>
        <Box {...styles.container}>
          <Header navigation={navigation} hide={false} isEditing={isEditing} />
          <AddNewUserForm editData={{ passedData, accessRightsData, getJfsUserId, mid, hasSupersetPermission }} />
        </Box>
      </ModBox>
    </Box>
  )
}

export default EditUserRole
